import * as types from '../constants/actionTypes';
import _ from "lodash";

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function logs(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.LOGS__CLEAR__REQUESTED: {
            return INITIAL_STATE;
        }

        case types.LOGS__REQUESTED__SUCCEEDED: {
            const { logs, append, returnedCount } = action.payload;
            const newLogs = _.mapKeys(logs.entities, id);

            // Store the returnedCount in a special property that won't interfere with log entries
            const result = append ? { ...state, ...newLogs } : newLogs;

            // Add metadata about the last fetch (use a key that can't conflict with log IDs)
            result.__meta = { returnedCount };

            return result;
        }

        default:
            return state;
    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/logsReducer.js
 **/